import { Navigate } from 'react-router-dom';

const RouteNotFound = () => <Navigate to="/" replace />;

export default RouteNotFound;
